import {CoreDI, CoreSettingsParameters, Device, DeviceType, inject, injectable, IService, Settings, SystemComponentType} from '@gongxigames/framework/core';
import {SlotSettingsParameters} from '@gongxigames/framework/slot/configs/SlotSettings';
import {EnvironmentProperty, GameConfig} from '@gongxigames/framework/slot/types';
import {errorReporter} from '@gongxigames/framework/core/utils';

@injectable()
export class InitializationEnvironmentSettingsService implements IService {
    public static NAME = 'InitializationEnvironmentSettingsService';
    public type: SystemComponentType = 'service';

    @inject(CoreDI.Settings)
    private readonly _settings!: Settings<SlotSettingsParameters & CoreSettingsParameters>;
    @inject(CoreDI.EnvironmentProperty)
    private readonly _environmentProperty!: EnvironmentProperty;
    @inject(CoreDI.GameConfig)
    private readonly _gameConfig!: GameConfig;
    @inject(CoreDI.Device)
    private readonly _device!: Device;

    public init(): void {
        this._gameConfig.clientVersion = this._environmentProperty.buildProperty.versions.clientVersion;

        if (this._settings.get('offlineMode') && this._gameConfig.clientSettings) {
            this._settings.setParameters(this._gameConfig.clientSettings);
        }

        this._settings.set('cdn', this._environmentProperty.cdn);
        this._settings.set('root', this._environmentProperty.root);
        this._settings.set('sessionsURL', this._environmentProperty.sessionsURL);
        this._settings.set('platform', this.getDeviceType());

        const resolution = Number(this._environmentProperty.buildProperty.gameProperty.mobilPack?.resolution);

        if (resolution) {
            this._settings.set('resolution', resolution);
        }

        if (this._settings.get('disableClientErrorReporting')) {
            errorReporter.disable();
        }
    }

    private getDeviceType(): DeviceType {
        const overrides = [DeviceType.DESKTOP, DeviceType.MOBILE];
        const override = this._settings.get('device');

        if (this._environmentProperty.buildProperty.gameProperty.mobilPack?.platform) {
            return this._environmentProperty.buildProperty.gameProperty.mobilPack?.platform as DeviceType;
        }

        if (override && overrides.includes(override)) {
            return override as DeviceType;
        }

        return this._device.deviceType;
    }
}
